import type { NsDict } from '../ru';

export const lobby: NsDict<'lobby'> = {
  title: 'Lobby',
  intro: 'Prognostizieren Sie die Bewegung eines verdeckten Index aus drei S&P-500-Aktien: zuerst nur der Chart, dann die Skala und erst in der letzten Runde die Zusammensetzung.',
  balance: 'Guthaben',
  atTables: 'An Tischen',
  openTables: 'Offene Tische',
  tables: 'Tische',
  rulesBtn: 'Regeln und Gewinnberechnung',
  creditsNote: 'Spiel-Credits können nicht gekauft, verkauft, übertragen oder getauscht werden.',
  restore: 'Startguthaben {amount|cr} wiederherstellen',
  'stat.games': 'Spiele',
  'stat.winRate': 'Gewinnquote',
  'stat.net': 'Nettoergebnis',
  'stat.avgError': 'Mittlerer Fehler',
  profileLink: 'Profil, Verlauf und Statistik',
  verifyTitle: 'Spielprüfung',
  verifyTextBefore:
    'Nach jedem Spiel kann ein Teilnehmer ein signiertes Paket herunterladen: alle Züge, die Zusammensetzung und die Ausgangskurse der Aktien, die Abrechnung und die Buchungen. Sie können es hier prüfen oder mit dem Werkzeug',
  verifyTextAfter: 'und die Kurse mit einer beliebigen externen Quelle vergleichen.',
  verifyBtn: 'Paketdatei prüfen…',

  flowTitle: 'So läuft ein Spiel ab',
  'flow.prep': 'Vorbereitung',
  'flow.prepText': 'Ante N in den Pot, Hash der Zusammensetzung veröffentlicht',
  'flow.prepTextAnte': 'Ante {ante|cr} in den Pot, Hash der Zusammensetzung veröffentlicht',
  'flow.round1': 'Runde 1 · Chart',
  'flow.round1Text': 'ohne Preisskala; Wahl der Richtung',
  'flow.round2': 'Runde 2 · Skala',
  'flow.round2Text': 'Preise und Abstände in Punkten',
  'flow.round2TextWr': 'Preise und Punkte; die Richtung kann geändert werden',
  'flow.round3': 'Runde 3 · Zusammensetzung',
  'flow.round3Text': 'drei Aktien aufgedeckt; Anzahl der Punkte',
  'flow.round3TextWr': 'drei Aktien aufgedeckt; nur die Anzahl der Punkte',
  'flow.target': 'Zielkerze',
  'flow.targetText': 'P₁ — Schluss der nächsten Minute',
  'flow.settle': 'Abrechnung und Prüfung',
  'flow.settleText': 'Auszahlungen nach Genauigkeit; Prüfpaket',
  'flow.settleWr': 'Abrechnung',
  'flow.settleTextWr': 'es gewinnen alle mit der richtigen Richtung; der Anteil hängt von der Genauigkeit ab',

  'cat.n10': 'Einsteiger',
  'cat.n50': 'Standard',
  'cat.n200': 'Hoch',
  'cat.anteN': 'Ante N',
  'cat.players': 'Spieler',
  'cat.rounds': 'Runden',
  'cat.roundsValue': '3 × {s} s',
  'cat.commission': 'Kommission',
  'cat.tables': 'Tische',
  'cat.roomsCount': '{rooms} · Spieler {seated}',
  'cat.noOpen': 'keine offen',
  'cat.newTable': 'Ein neuer Tisch wird eröffnet.',
  'cat.return': 'Zurück zum Tisch',
  'cat.sit': 'Platz nehmen',
  notEnough: 'Nicht genug Credits für das Ante.',

  'room.playing': 'Spiel läuft',
  'room.startIn': 'Start in {n} s',
  'room.settling': 'Abrechnung',
  'room.ready': 'bereit {ready} von {min}',
  'room.taken': 'belegt {seated} von {max}',
  'room.open': 'Öffnen',
  'room.watch': 'Zuschauen',

  'wr.startIn': 'Das Spiel beginnt in {n} s',
  'wr.waitMore': 'Warten auf {n} weitere Bestätigung|Warten auf {n} weitere Bestätigungen',
  'wr.allReady': 'Alle sind bereit',
  'wr.preparing': 'Das nächste Spiel wird vorbereitet',
  'wr.summary': 'Tisch {ante|cr} · {min}–{max} Spieler · am Tisch {seated}, bereit {ready}',
  'wr.botsNote': 'Wenn nicht genug Personen da sind, füllen Bots den Tisch auf (sie sind gekennzeichnet).',
  'wr.spectating': 'Sie schauen an diesem Tisch zu.',
  'wr.confirmed': '✓ Teilnahme bestätigt.',
  'wr.anteOnStart': 'Das Ante von {ante|cr} wird beim Start abgebucht.',
  'wr.cancel': 'Teilnahme zurückziehen',
  'wr.join': 'Teilnehmen · Ante {ante|cr}',
  'wr.yourBalance': 'Ihr Guthaben {amount|cr}',
  'wr.seats': 'Plätze am Tisch',
  'wr.you': 'Sie',
  'wr.gamesCount': 'Spiele: {n}',
  'wr.winRateShort': 'GQ',
  'wr.offline': 'keine Verbindung',
  'wr.ready': 'bereit',
  'wr.waiting': 'wartet',
  'wr.free': 'frei',

  'rules.title': 'Regeln von Market Table',
  'rules.demo': 'Eine Demo mit Spiel-Credits. Es gibt kein echtes Geld, keine Zahlungen, keinen Kauf und keine Auszahlung von Credits. Keine Anlageempfehlung.',
  'rules.indexTitle': 'Der Spielindex',
  'rules.indexText':
    'Vor jedem Spiel wählt der Server zufällig drei verschiedene Aktien aus einer offenen Auswahl liquider S&P-500-Aktien. Der Index ist eine gleichgewichtete Kombination ihrer prozentualen Veränderungen gegenüber dem Schluss der Kerze P₀:',
  'rules.index1': 'Bᵢ — Schlusskurs der Aktie in der Kerze P₀; Preisschritt {tick} Punkte; Rundung auf den nächsten Schritt, die Hälfte wird aufgerundet.',
  'rules.index2': 'O/C der Kerze — Index aus Eröffnungs-/Schlusskursen; H/L — aus Hochs/Tiefs der Komponenten (Schätzung nach oben/unten), aber nie enger als O und C.',
  'rules.index3': 'In einer Minute ohne Umsätze in einer Aktie wird ihr letzter Kurs verwendet.',
  'rules.index4': '„Aktivität“ — das über die drei Aktien gemittelte Minutenvolumen, geteilt durch das durchschnittliche Volumen der Aktie im Verlaufsfenster (1 = normal). VWAP* ist nach Aktivität gewichtet.',
  'rules.index5': 'Die Formel ist offen; verdeckt ist nur die Zusammensetzung des Trios — bis zur dritten Runde. Das Hash-Commitment wird vor den Einsätzen veröffentlicht und nach der Abrechnung aufgedeckt.',
  'rules.flowTitle': 'Ablauf eines Spiels',
  'rules.flow1': 'Das Ante N geht in den Pot, P₀ wird festgehalten.',
  'rules.flow2': 'Runde 1: Chart ohne Skala, Wahl der Richtung (höher/tiefer) und Einsätze.',
  'rules.flow3': 'Runde 2: Die Preisskala und die Abstände in Punkten werden aufgedeckt. Die Richtung kann beibehalten oder geändert werden.',
  'rules.flow4': 'Runde 3: Die Zusammensetzung wird aufgedeckt. Die Richtung ändert sich nicht mehr — geben Sie eine streng positive Anzahl Punkte an (Schritt {tick}).',
  'rules.flow5': 'Fixierung. P₁ ist der Schluss der nächsten Minutenkerze; Δ = P₁ − P₀.',
  'rules.actionsTitle': 'Aktionen',
  'rules.actionsText':
    'Fold, Check, Bet, Call, Raise (höchstens eine Erhöhung nach dem ersten Einsatz in der Runde), All-in (mit Side-Pots). Zeit pro Zug: {s} s; bei Zeitablauf Check, wenn möglich, sonst Fold. Am Ende der Runde foldet nur, wessen Zugzeit abgelaufen ist. Wer keinen Zug mehr bekommen hat, bleibt im Spiel: der nicht gecallte Teil des Einsatzes wird zurückgegeben. Wer bei der Fixierung keine vollständige Prognose hat, scheidet aus.',
  'rules.payoutTitle': 'Gewinner und Auszahlungen',
  'rules.payout1': 'Eine falsche Richtung verliert immer, auch bei exakter Punktzahl.',
  'rules.payout2':
    'Für alle mit richtiger Richtung: Fehler = |Prognose − |Δ||; Gewicht = Beitrag_zum_Pot / (1 + Fehler / {tick}). Der Pot wird im Verhältnis der Gewichte geteilt; Reste von 0,01 Cr nach dem Verfahren der größten Reste, bei Gleichstand nach Zugreihenfolge.',
  'rules.payout3': 'Jeder Side-Pot wird separat abgerechnet; Anspruch haben nur, wer eingezahlt und nicht gefoldet hat. Ein Pot ohne richtige Richtung geht an die Einzahler zurück.',
  'rules.payout4': 'Abbruch mit voller Rückerstattung und ohne Kommission: P₁ = P₀; niemand der Verbliebenen hat die Richtung erraten; keine verlässlichen Daten.',
  'rules.payout5': 'Haben alle bis auf einen gefoldet, erhält der Verbliebene den Pot ohne Prüfung der Prognose.',
  'rules.exampleTitle': 'Beispiel',
  'rules.exampleText':
    'Vier Spieler, Ante 10 Cr; Δ = +2,00. Spieler A: „höher 2,00“ (Fehler 0, Gewicht 10), B: „höher 2,25“ (Fehler 0,25 = 1 Schritt, Gewicht 10/2 = 5), C und D — „tiefer“. Pot 40 Cr, Kommission 5 % = 2 Cr; zu verteilen 38 Cr: A — 25,33 Cr, B — 12,67 Cr.',
  'rules.commissionTitle': 'Kommission',
  'rules.commissionText':
    '{pct} % der neuen Credits, die in jeder Runde in den Pot eingezahlt werden (in der ersten zusammen mit den Antes). Früher Eingezahltes und Zurückgegebenes wird nicht belastet; bei Abbruch wird keine Kommission einbehalten.',
  'rules.capOne': 'ein Ante',
  'rules.capMany': '{n} Ante|{n} Antes',
  'rules.cap': 'Die Obergrenze liegt bei {antes} N pro Runde, also höchstens {max}N pro Spiel (wie ein Rake-Cap beim Poker).',
  'rules.retained': 'Der einbehaltene Betrag fließt auf ein separates Hauskonto der Demo.',
  'rules.hotkeysTitle': 'Tastenkürzel',
  'rules.hotkeys': '↑/↓ Richtung · +/− Punkte (Shift ×4) · F Fold · C Check/Call · B Bet/Raise · A All-in · Enter bestätigen · Esc abbrechen',
};
